import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

const GuestEvaluationThanks: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-xl shadow-md p-6 space-y-4 text-center">
        <div className="flex justify-center">
          <CheckCircle2 size={32} className="text-emerald-600" />
        </div>
        <h1 className="text-xl font-semibold text-gray-900">Bedankt!</h1>
        <p className="text-sm text-gray-600">
          Je evaluatie is succesvol opgeslagen.
        </p>
        <button
          type="button"
          onClick={() => navigate('/evaluation-access')}
          className="inline-flex items-center justify-center rounded-md bg-primary-600 text-white px-3 py-2 text-sm font-medium hover:bg-primary-700"
        >
          Nieuwe evaluatie openen
        </button>
      </div>
    </div>
  );
};

export default GuestEvaluationThanks;
